document.addEventListener('DOMContentLoaded', function() {
    // Controlla se il dominio è "meridiana1822.store" e se la pagina corrente è la home page
    if (window.location.hostname === 'meridiana1822.store' && 
        (window.location.pathname === '/' || window.location.pathname === '/index.html')) {
        
        const loaderContainer = document.createElement('div');
        loaderContainer.classList.add('loader-container');
        document.body.appendChild(loaderContainer);

        const logo = document.createElement('img');
        logo.classList.add('logo');
        logo.src = logoUrl;  // Utilizza la variabile definita nel theme.liquid
        logo.alt = 'Logo';
        loaderContainer.appendChild(logo);

        const particleCount = 50;

        function createParticles() {
            for (let i = 0; i < particleCount; i++) {
                const particle = document.createElement('div');
                particle.classList.add('particle');
                loaderContainer.appendChild(particle);
                console.log('Particelle create:', i);

                const angle = Math.random() * Math.PI * 2;
                const radius = Math.random() * 100 + 50;
                const x = Math.cos(angle) * radius;
                const y = Math.sin(angle) * radius;
                gsap.set(particle, { x, y });
                
                gsap.to(particle, {
                    duration: 4,
                    x: 100,
                    y: 0,
                    opacity: 1,
                    ease: "power2.in",
                    delay: Math.random() * 0.5,
                    force3d: true
                });
            }
        }

        gsap.to(logo, {
            duration: 1,
            opacity: 1,
            scale: 1,
            ease: "power2.out",
            delay: 1.5
        });

        createParticles();

        window.addEventListener('load', function() {
            gsap.to(loaderContainer, {
                duration: 0.5,
                opacity: 0,
                onComplete: function() {
                    loaderContainer.style.display = 'none';
                }
            });
        });
    }
});